/*
 * decaffeinate suggestions:
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import $ from 'jquery';

import ImportSequenceModalClass from 'import-sequence/ImportSequenceModal';
import {DNA_SEQUENCE_IMPORT_FLOW} from 'molbio/MolBioConstants';
import ifCreateFromHash from 'util/ifCreateFromHash';
import runModal from 'ui-library/runModal';

class ImportSequenceHashView extends Backbone.View {
  render() {
    function openModal(currentHash) {
      const props = {};
      if (currentHash != null && currentHash.indexOf('dbimport') !== -1) {
        props.initialTab = DNA_SEQUENCE_IMPORT_FLOW.DB;
      }
      runModal(ImportSequenceModalClass, props);
    }

    $(document).on('click', '.js-import-sequence', (e) => {
      e.preventDefault();
      openModal();
    });

    ifCreateFromHash('#import-sequence', openModal);
    return this;
  }
}

export default ImportSequenceHashView;
